// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.DEXT_fiVe_UP_ly_wrapper[data-v-88ec4fb8]{\n  z-index: 99999999 !important;\n}\n", ""]);
// Exports
module.exports = exports;
